import { ShieldCheck } from "lucide-react";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="relative border-t border-white/10 bg-[#080c17]">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-14 grid gap-10 lg:grid-cols-4">
        <div>
          <div className="flex items-center gap-2">
            <div className="w-8 h-8 rounded-md bg-gradient-to-br from-[#10B981] to-[#0e8f66] grid place-items-center">
              <ShieldCheck className="w-4 h-4 text-white" strokeWidth={2.5} />
            </div>
            <span className="font-display text-lg font-bold tracking-tight">
              Go <span className="text-[#D4AF37]">Higher</span>
            </span>
          </div>
          <p className="mt-4 text-sm text-white/50 max-w-xs leading-relaxed">
            Ethical online reputation management for local businesses.
            No fake reviews. No black-hat tactics. Just results.
          </p>
        </div>

        <FooterCol
          title="Services"
          links={[
            ["Google review removal", "#services"],
            ["Reddit review removal", "#services"],
            ["Glassdoor review removal", "#services"],
            ["Airbnb review removal", "#services"],
            ["Trustpilot review removal", "#services"],
            ["Monitoring & maintenance", "#services"],
          ]}
        />
        <FooterCol
          title="Company"
          links={[
            ["How it works", "/#how"],
            ["Pricing", "/#pricing"],
            ["Blog", "/blog"],
            ["Book a free call", "/#book-call"],
            ["FAQ", "/#faq"],
            ["Contact", "/#audit"],
          ]}
        />
        <div>
          <div className="text-xs uppercase tracking-[0.14em] text-white/40 font-semibold mb-3">
            Contact
          </div>
          <ul className="space-y-2 text-sm text-white/60">
            <li>
              <a href="mailto:info@igohigher.com" className="hover:text-white transition-colors">
                info@igohigher.com
              </a>
            </li>
            <li>
              <a href="tel:+923338575859" className="hover:text-white transition-colors">
                +92 333 857 5859
              </a>
            </li>
            <li>Mon–Fri · 9am–6pm ET</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/5">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 py-6 flex flex-wrap items-center justify-between gap-4 text-xs text-white/40">
          <div>© {new Date().getFullYear()} Go Higher, Inc. All rights reserved.</div>
          <div className="flex items-center gap-6">
            <Link
              to="/privacy"
              data-testid="footer-privacy-link"
              className="hover:text-white transition-colors"
            >
              Privacy policy
            </Link>
            <Link
              to="/terms"
              data-testid="footer-terms-link"
              className="hover:text-white transition-colors"
            >
              Terms of service
            </Link>
            <Link
              to="/blog"
              data-testid="footer-blog-link"
              className="hover:text-white transition-colors"
            >
              Blog
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}

function FooterCol({ title, links }) {
  return (
    <div>
      <div className="text-xs uppercase tracking-[0.14em] text-white/40 font-semibold mb-3">
        {title}
      </div>
      <ul className="space-y-2 text-sm text-white/60">
        {links.map(([label, href]) => (
          <li key={label}>
            <a href={href} className="hover:text-white transition-colors">
              {label}
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
}
